module.exports = __webpack_public_path__ + "static/media/Daisy & Gareth Kitchen (18).c05b87c9.jpg";